export const ModulesList = [
  {
    id: "",
    label: "Users",
    name: "users",
    status: "",
    maintenanceId: "",
  },
  {
    id: "",
    label: "Reservations",
    name: "reservations",
    status: "",
    maintenanceId: "",
  },
  {
    id: "",
    label: "News",
    name: "news",
    status: "",
    maintenanceId: "",
  },
  {
    id: "",
    label: "Collaboration",
    name: "collaboration",
    status: "",
    maintenanceId: "",
  },
  {
    id: "",
    label: "Contact US",
    name: "contactUs",
    status: "",
    maintenanceId: "",
  },
  {
    id: "",
    label: "Social Media",
    name: "socialMedia",
    status: "",
    maintenanceId: "",
  },
];
